module.exports = __webpack_public_path__ + "img/sprinkle-20.9fd38fa7.webp";